import { useContext } from "react";
import { IboContext } from "../context/iboContext";
import { LanguageContext } from "../context/languageContext";
import { ProspectContext } from "../context/prospectContext";
import {
  createContact,
  getByContactId,
  getContactRelationIbo,
  getInfoByEmail,
  getListIdentificationType,
} from "../helpers/userVT.helper";

const useUser = () => {
  const { iboInfo } = useContext(IboContext);
  const { prospectInfo } = useContext(ProspectContext);
  const { language } = useContext(LanguageContext);

  const getUserByEmail = async (email) => {
    const response = await getInfoByEmail(email);
    return response;
  };

  const getUserByContactId = async () => {
    const response = await getByContactId(
      language,
      prospectInfo?.id,
      iboInfo.tokenVT
    );
    return response;
  };

  const getIdentificationType = async () => {
    const response = await getListIdentificationType(language, iboInfo.tokenVT);
    return response;
  };

  const create = async (payload) => {
    const response = await createContact(payload);
    return response;
  };

  const getContactRelation = async (payload) => {
    const response = await getContactRelationIbo(payload, iboInfo.tokenVT);
    return response;
  };

  return {
    getUserByEmail,
    create,
    getUserByContactId,
    getIdentificationType,
    getContactRelation,
  };
};

export default useUser;
